module.exports = __webpack_public_path__ + "img/icon-r-play-dark.627c1d69.svg";